import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/check.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M20.1034 5.10327C20.5373 4.66935 21.2406 4.66935 21.6746 5.10327C22.1085 5.53719 22.1085 6.24055 21.6746 6.67447L9.45224 18.8968C9.01832 19.3307 8.31496 19.3307 7.88104 18.8968L2.32544 13.3412C1.89152 12.9073 1.89152 12.2039 2.32544 11.77C2.73224 11.3632 3.37558 11.3381 3.812 11.694L3.89663 11.77L8.66664 16.54L20.1034 5.10327Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as CheckIcon };
